import { styled } from 'inlines'
import {
  faGoogle,
  faApple,
  faMicrosoft,
} from '@fortawesome/free-brands-svg-icons'
import { useTranslations } from '@i18n/useLanguage'
import { Modal } from './Modal'
import { Button } from '@app/components/core/button/Button'
import {
  googleCalendarUrl,
  outlookCalendarUrl,
  downloadIcs,
} from '@app/util/calendarLinks'
import type { ViewEventModel } from 'functions/app/event/view'
import Column from '@app/components/layout/Column'

export type AddToCalendarModalProps = {
  isOpen: boolean
  onClose: () => void
  event: ViewEventModel
}

export const AddToCalendarModal = ({
  isOpen,
  onClose,
  event,
}: AddToCalendarModalProps) => {
  const t = useTranslations().app.eventPage.addToCalendarModal

  const handleGoogle = () => {
    window.open(googleCalendarUrl(event), '_blank')
    onClose()
  }

  const handleOutlook = () => {
    window.open(outlookCalendarUrl(event), '_blank')
    onClose()
  }

  const handleIcs = () => {
    downloadIcs(event)
    onClose()
  }

  const buttonStyle = {
    width: '100%',
    justifyContent: 'flex-start',
    borderRadius: '0.75rem',
    border: 'var(--border-subtle)',
    backgroundColor: 'var(--palette-white)',
    padding: '0.75rem 1rem',
    height: 'auto',
    fontSize: '1rem',
    gap: '0.75rem',
    '&:hover': {
      backgroundColor: 'var(--palette-blue-50)',
    },
  } satisfies import('inlines').Style

  return (
    <Modal
      isOpen={isOpen}
      title={t.title}
      onClose={onClose}
      backLabel={t.close}
    >
      <Column gap="0.5rem">
        <Button
          icon={faGoogle}
          label={t.googleCalendar}
          iconPosition="left"
          variant="secondary"
          onClick={handleGoogle}
          style={buttonStyle}
        />

        <Button
          icon={faMicrosoft}
          label={t.outlook}
          iconPosition="left"
          variant="secondary"
          onClick={handleOutlook}
          style={buttonStyle}
        />

        <Button
          icon={faApple}
          label={t.appleCalendar}
          iconPosition="left"
          variant="secondary"
          onClick={handleIcs}
          style={buttonStyle}
        />
      </Column>
    </Modal>
  )
}
